import { withSuspense } from '@lib/common/hoc';
import { lazy } from 'react';

const DatabaseLogsSearchPage = withSuspense(lazy(() => import('./database-logs-search')));
export default DatabaseLogsSearchPage;
